import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable, observable } from 'mobx';

import type { SSORegistrationDto } from '@/shared/application/interfaces/pegasus-io.gateway';

import { GetSSORegistrationsCollaboration } from '../../../application/collaborations/sso/get-sso-registrations.collaboration';

@ViewModel({ singleton: true })
export class SSORegistrationsViewModel implements IReactiveModel {
  @observable ssoRegistration: SSORegistrationDto[] = [];
  @observable isLoading = false;
  @observable hasError = false;

  constructor(private getSSORegistrationsCollaboration: GetSSORegistrationsCollaboration) {
    makeAutoObservable(this);
  }

  @action
  async onInit() {
    try {
      this.isLoading = true;

      const { data } = await this.getSSORegistrationsCollaboration.run();
      this.ssoRegistration = data;
    } catch (error) {
      console.error(error);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }
}
